import { periods } from "_constants";

const budgetFilter = (filter, { budget, budgetPeriod }) => {
  const budgetNormalized = budget;
  if (!filter || (!filter.from && !filter.to)) return true;
  if (!budgetNormalized) return false;
  if (filter.period !== budgetPeriod) {
    budgetNormalized.from = budget.from * (periods[budgetPeriod] / periods[filter.period]);
    budgetNormalized.to = budget.to * (periods[budgetPeriod] / periods[filter.period]);
  }

  return (
    (filter.from <= budgetNormalized.from &&
      budgetNormalized.to <= filter.to &&
      budgetNormalized.unit === filter.unit) ||
    (filter.from <= budgetNormalized.to && !filter.to) ||
    (budgetNormalized.from <= filter.to && !filter.from)
  );
};

export default budgetFilter;
